import {
  cartItemsStyling,
  cartSummaryStyling,
  cartTotalsStyling,
  cartSummaryBirchStyling,
  voucherListBlueprint,
  voucherInputBlueprint,
} from "@made-people/blueprint-cart-summary/blueprint";

cartSummaryStyling.override({
  slots: {
    wrapper: "flex flex-col ",
  },
});

cartTotalsStyling.override({
  slots: {
    wrapper:
      "flex group-[.mini-cart]/mini-cart:hidden group-[.mini-cart]/mini-cart:lg:flex flex-col items-center w-full pt-6 lg:flex",
    row: "flex justify-between w-full group/cart-row last:mt-3",
    label:
      "text-body-md group-last/cart-row:text-body-lg group-last/cart-row:font-bold",
    value:
      "text-body-md group-last/cart-row:text-body-lg group-last/cart-row:font-bold",
  },
});

cartItemsStyling.override({
  slots: {
    wrapper: "flex flex-col gap-4 items-center w-full",
  },
});

cartSummaryBirchStyling.override({
  slots: {
    wrapper: "flex flex-col",
    header: "flex w-full",
    cartWrapper:
      "flex flex-col gap-6 items-center w-full overflow-x-hidden border-border-light border-b pb-0",
  },
  variants: {
    heading: {
      hide: {
        header: "hidden",
      },
    },
  },
});

voucherInputBlueprint.override({
  slots: {
    base: "w-full flex flex-col gap-3 py-3",
    trigger:
      "bg-background-page px-3 h-12 flex items-center rounded-md justify-center",
    inputWrapper: "flex gap-2",
  },
});

voucherListBlueprint.override({
  slots: {
    base: "w-full flex flex-col empty:hidden gap-2",
    item: "flex justify-between data-[state=loading]:animate-pulse gap-3",
    deleteButton:
      "text-label-md text-less-emphasis-1 underline underline-offset-2",
    discount: "flex-1 text-right",
  },
});
